function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpicenterNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "26px",
    viewBox: "0 0 30 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fillOpacity: 1
    },
    d: "M 20.007812 3.929688 L 25.175781 12.910156 L 20.007812 21.890625 L 9.683594 21.890625 L 4.515625 12.910156 L 9.683594 3.929688 Z M 22.269531 0 L 7.421875 0 L 0 12.914062 L 7.421875 25.828125 L 22.269531 25.828125 L 29.691406 12.914062 Z M 22.269531 0 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicenterNoText);
export default __webpack_public_path__ + "static/media/epicenter_no_text.6707c7ab.svg";
export { ForwardRef as ReactComponent };